import { useBlockProps } from '@wordpress/block-editor';
import ShapeSvg from './shape-svg';
import { getWrapperClasses, getWrapperStyles } from './styles';

export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  return (
    <div {...blockProps}>
      <ShapeSvg attributes={attributes} />
    </div>
  );
}
